import { apiClientV2 } from '@/services/rest-api/apiClient'

const baseURL = process.env.VUE_APP_API_VMS_URL

export const get = async (queryParam, filters) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: filters || undefined,
  }

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/contract`,
    params
  })

  return response?.data
}

export const getWithFilters = (filters) => async (queryParam) => await get(queryParam, filters)

export const show = async (vendorId, contractId, versionId) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/vendor/${vendorId}/contract/${contractId}/version/${versionId}`,
  })

  return response?.data
}

export const store = async (vendorId, data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: `/vendor/${vendorId}/contract`,
    data
  })

  return response?.data
}

export const update = async (vendorId, contractId, versionId, data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'PATCH',
    url: `/vendor/${vendorId}/contract/${contractId}/version/${versionId}`,
    data
  })

  // If no data but status is 200
  if (!response?.data && String(response?.status).startsWith('2')) {
    return 'OK'
  }

  return response?.data
}
